import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAdmin } from '../context/AdminContext';

const AdminLayout = () => {
  const { admin, logout } = useAdmin();
  const location = useLocation();

  const menuItems = [
    { path: '/admin/dashboard', name: 'Dashboard', icon: 'fas fa-chart-line' },
    { path: '/admin/inquiries', name: 'Inquiries', icon: 'fas fa-question-circle' },
    { path: '/admin/cms', name: 'Website CMS', icon: 'fas fa-globe' },
    { path: '/admin/menu-manager', name: 'Menu Manager', icon: 'fas fa-bars' },
    { path: '/admin/categories', name: 'Categories', icon: 'fas fa-tags' },  // ADDED
    { path: '/admin/settings', name: 'Settings', icon: 'fas fa-cog' },
    { path: '/admin/view-website', name: 'View Website', icon: 'fas fa-external-link-alt', external: true }
  ];

  const isActive = (path) => location.pathname === path;

  const handleViewWebsite = () => {
    window.open('/', '_blank');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#F7F9FC' }}>
      {/* Sidebar */}
      <div style={{
        width: '280px',
        background: '#0A192F',
        color: 'white',
        position: 'fixed',
        height: '100vh',
        overflowY: 'auto'
      }}>
        {/* Logo Area */}
        <div style={{ 
          padding: '1.5rem', 
          borderBottom: '1px solid #1E3A5F',
          textAlign: 'center'
        }}>
          <h3 style={{ color: 'white', marginBottom: '0.25rem', fontSize: '1.2rem' }}>
            INTELIHEADS
          </h3>
          <p style={{ fontSize: '0.7rem', opacity: 0.7 }}>Admin Panel</p>
        </div>
        
        {/* Navigation Menu */}
        <nav style={{ padding: '1rem 0' }}>
          {menuItems.map((item, index) => {
            if (item.external) {
              return (
                <button
                  key={index}
                  onClick={handleViewWebsite}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    padding: '0.75rem 1.5rem',
                    width: '100%',
                    color: '#A0B4C8',
                    textDecoration: 'none',
                    transition: 'all 0.2s',
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '0.9rem'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#1E3A5F';
                    e.currentTarget.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#A0B4C8';
                  }}
                >
                  <i className={item.icon} style={{ width: '20px' }}></i>
                  <span style={{ flex: 1, textAlign: 'left' }}>{item.name}</span>
                  <i className="fas fa-external-link-alt" style={{ fontSize: '0.7rem' }}></i>
                </button>
              );
            }
            
            return (
              <Link
                key={index}
                to={item.path}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  padding: '0.75rem 1.5rem',
                  color: isActive(item.path) ? 'white' : '#A0B4C8',
                  textDecoration: 'none',
                  transition: 'all 0.2s',
                  background: isActive(item.path) ? '#1E3A5F' : 'transparent',
                  borderLeft: isActive(item.path) ? '3px solid #2C7A7B' : '3px solid transparent'
                }}
                onMouseEnter={(e) => {
                  if (!isActive(item.path)) {
                    e.currentTarget.style.background = '#1E3A5F';
                    e.currentTarget.style.color = 'white';
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive(item.path)) {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#A0B4C8';
                  }
                }}
              >
                <i className={item.icon} style={{ width: '20px' }}></i>
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>
        
        {/* Logout Button */}
        <div style={{ 
          position: 'absolute', 
          bottom: 0, 
          width: '100%', 
          padding: '1rem', 
          borderTop: '1px solid #1E3A5F',
          background: '#0A192F'
        }}>
          <button
            onClick={logout}
            style={{
              width: '100%',
              padding: '0.75rem',
              background: 'transparent',
              border: '1px solid #DC2626',
              color: '#DC2626',
              borderRadius: '8px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#DC2626';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#DC2626';
            }}
          >
            <i className="fas fa-sign-out-alt"></i>
            Logout
          </button>
        </div>
      </div>
      
      {/* Main Content */}
      <div style={{ marginLeft: '280px', flex: 1 }}>
        {/* Top Bar */}
        <div style={{
          background: 'white',
          padding: '1rem 2rem',
          borderBottom: '1px solid #E2E8F0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}>
          <div>
            <h2 style={{ color: '#0A192F', fontSize: '1.25rem', marginBottom: '0.25rem' }}>
              Welcome, {admin?.name || admin?.email || 'Admin'}!
            </h2>
            <p style={{ color: '#5A6E7F', fontSize: '0.875rem' }}>
              {admin?.role === 'super_admin' ? 'Super Administrator' : 'Administrator'}
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <span style={{ color: '#5A6E7F' }}>
              <i className="fas fa-calendar-alt"></i> {new Date().toLocaleDateString('en-US', { 
                weekday: 'long', 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
              })}
            </span>
          </div>
        </div>
        
        {/* Page Content */}
        <div style={{ padding: '2rem' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;